// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"146":"6bade90e","872":"18ec2121"}[chunkId] + ".chunk.css";
};